import * as actionTypes from "../_constants/index";

const initialState = {
  loading: false,
    user: [],
    error: null
  };

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    // FOR REGISTER
    case actionTypes.REGISTER_BEGIN:
      return {
        ...state,
        loading: true
      }
    case actionTypes.REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload
      }
    case actionTypes.REGISTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }

      // FOR LOGIN
    case actionTypes.LOGIN_BEGIN:
      return {
        ...state,
        loading: true
      }
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload
      }
    case actionTypes.LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default:
      return state;
  }
};

export default userReducer;